<template>
  <div>
    <!-- <div class="text-center">
      <div class="titleWrapper">
        <div class="bar"></div>
        <div class="title py-15">{{committee.dicName}}</div>
        <div class="bar"></div>
      </div>
      <div class="tel">{{committee.phoneNO}}</div>
      <div class="tel content">{{committee.remark}}</div>
      <Button
        class="title-btn"
        type="warning"
        @click="edit('committee')"
      >编辑{{committee.dicName}}信息</Button>
    </div> -->
    <div class="companyBlock">
      <row type="flex" justify="center">
        <template v-for="(item,index) in list">
          <i-col class="text-center" span="10">
            <div class="titleWrapper">
              <div class="bar"></div>
              <div class="title py-15">{{item.dicName}}</div>
              <div class="bar"></div>
            </div>
            <div class="tel mt-38">{{item.phoneNO}}</div>
            <div class="tel">{{item.companyName}}</div>

            <div class="tel" v-if="item.address">
              <i class="iconfont icon-dingweiweizhi"></i>
              {{item.address}}
            </div>
            <Button class="title-btn" type="warning" @click="edit(item)">编辑{{item.dicName}}信息</Button>
          </i-col>
        </template>
      </row>
    </div>

    <Modal
      v-model="showModal"
      title="编辑信息"
      :mask-closable="false"
      width="600"
      @on-ok="changeXiangqing"
      @on-cancel="closeXiangqing"
    >
      <Input
        v-model="companyName"
        size="large"
        placeholder="请输入企业名称"
        :disabled="isCommittee"
        style="margin-bottom: 10px"
      />
      <Input v-model="phoneNum" size="large" placeholder="请输入管理员电话" style="margin-bottom: 10px" />

      <div
        v-if="!isCommittee"
        class="address"
        :class="{ address_nodata: !map.zuobiao.label }"
        @click="map.showMap = true"
      >
        {{ map.zuobiao.label || map.placeholder }}
        <i class="iconfont icon-dingweiweizhi"></i>
      </div>
      <map-modal
        v-if="map.showMap"
        :zuobiao="map.zuobiao"
        @confirm="getAddress($event)"
        @cancel="map.showMap = false"
      ></map-modal>

      <Input
        v-if="isCommittee"
        v-model="remark"
        size="large"
        placeholder="请输入企业描述"
        type="textarea"
        :rows="6"
        :maxlength="1000"
      />
    </Modal>
  </div>
</template>

<script>
import api from "../../../api/index";
import mapModal from "@/components/mapModal";
const { getZoneProperty, addQy } = api;

export default {
  name: "zoneProperty",
  components: { mapModal },
  props: [],
  data() {
    return {
      zoneId: this.$route.query.zoneId || sessionStorage.zoneId,
      committee: {},
      isCommittee: false,
      showModal: false,
      companyName: "",
      companyId: null,
      phoneNum: "",
      remark: "",
      typeId: "",
      map: {
        label: "地址",
        placeholder: "请选择企业位置",
        showMap: false,
        zuobiao: {
          value: "",
          label: "",
        },
        value: {
          address: "",
          coordinate: "",
        },
      },
      list: [],
    };
  },
  methods: {
    async getZoneProperty() {
      this.list = []
      let res = await this.$get(getZoneProperty(this.zoneId));
      console.log(res);
      let data = res.newPrimaryKeys;
      for (const element in data) {
        // console.log(element);
        if (element == "company_type_operation") {
          this.committee = data[element];
        } else {
          this.list.push(data[element]);
        }
      }

      // console.log(this.committee);
      // console.log(this.list);
    },
    edit(item) {
      console.log(item);
      this.showModal = true;
      if (item == "committee") {
        this.isCommittee = true;
        this.typeId = this.committee.typeId;
        this.companyName = this.committee.dicName;
        this.companyId = this.committee.companyId;
        this.phoneNum = this.committee.phoneNO;
        this.remark = this.committee.remark;
        this.map.zuobiao.label = this.committee.address;
        let obj = this.committee.coordinate?JSON.parse(this.committee.coordinate):null;
        let coordinate =  obj ? obj.x + "," + obj.y : null;
        this.map.zuobiao.value = coordinate;
      } else {
        this.isCommittee = false;
        this.typeId = item.typeId;
        this.companyName = item.companyName;
        this.companyId = item.companyId;
        this.phoneNum = item.phoneNO;
        this.remark = item.remark;
        this.map.zuobiao.label = item.address;
        let obj = item.coordinate?JSON.parse(item.coordinate): null;
        console.log(obj);
        let coordinate = obj ? obj.x + "," + obj.y : null;
        this.map.zuobiao.value = coordinate;
      }
    },
    async changeXiangqing() {
      console.log(this.companyName);
      console.log(this.phoneNum);
      console.log(this.map.zuobiao);
      console.log(this.remark);
      var url = this.urlobj.getOrg();
      let res = await this.$post(addQy, {
        id: this.companyId,
        companyName: this.companyName,
        zoneId: this.zoneId,
        address: this.map.zuobiao.label,
        coordinate: this.map.zuobiao.value,
        remark: this.remark,
        managerPhoneNO: this.phoneNum,
        typeIdList: [this.typeId],
      });
      if (res.isSucceed) {
          this.$Message.success("修改成功");
          this.getZoneProperty();
      }
    },
    getAddress(val) {
      this.map.zuobiao = val;
      this.map.showMap = false;

      // 更新value
      let [x, y] = val.value.split(",");
      this.map.value = {
        address: val.label,
        coordinate: JSON.stringify({ x, y }),
      };
      console.log(this.map.value);
    },
    closeXiangqing() {
      this.$emit("closexiangqing");
    },
  },
  created() {
    console.log(this.zoneId);
    this.getZoneProperty();
  },
};
</script>
<style lang="less" scoped>
.titleWrapper {
  justify-content: center;
  display: flex;
  align-items: center;
  margin-top: 69px;
  .bar {
    width: 150px;
    height: 1px;
    background: #4b4b4b;
  }
  .title {
    font-size: 30px;
    font-weight: Bold;
    color: #4b4b4b;
  }
  .py-15 {
    padding: 0 15px;
  }
  .py-35 {
    padding: 0 35px;
  }
}

.text-center {
  text-align: center;
}
.tel {
  margin-top: 20px;
  font-size: 20px;
  color: #333333;
}
.content {
  text-align: left;
  line-height: 2;
}
.title-btn {
  margin-top: 40px;
  margin-bottom: 30px;
}
.companyBlock {
  background: #fffae0;
  margin-top: 38px;
  //   opacity: 0.6;
  .mt-38 {
    margin-top: 38px;
  }
  .icon-dingweiweizhi {
    color: #ff9900;
    padding-right: 5px;
  }
}
.address {
  width: 100%;
  height: 32px;
  line-height: 24px;
  padding: 4px 7px;
  font-size: 12px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  color: #515a6e;
  background-color: #fff;
  background-image: none;
  position: relative;
  cursor: text;
  margin-bottom: 10px;
  .icon-dingweiweizhi {
    float: right;
  }
}
.address_nodata {
  color: #bbb;
}
.address:hover {
  border: 1px solid #ff7b44;
}
.address:active {
  border: 1px solid #ff7b44;
}
</style>

